// extracted by mini-css-extract-plugin
export default {"Invoices":"BillInvoices_Invoices__V2cG5","InvoicesList":"BillInvoices_InvoicesList__UTz9j","InvoicesHeader":"BillInvoices_InvoicesHeader__YKhLn"};